<template>
  <div class="fm-questionnaire">
    <div
      v-for="(question, index) in questionnaire"
      :key="index"
    >
      <div v-if="step === index">
        <div class="fm-steps">{{ index + 1 }} of {{ questionnaire.length }}</div>
        <div v-if="question.type === 'singleChoice'">
          <single-choice
            :question="question"
            @proceed="nextStep"
          />
        </div>
        <div v-if="question.type === 'multipleChoice'">
          <multiple-choice
            :question="question"
            @proceed="nextStep"
          />
        </div>
        <div class="fm-answers__bottom">
          <button
            v-if="step < questionnaire.length - 1 && proceed"
            class="btn button btn-medium btn-bright "
            @click="
              step++;
              proceed = !proceed;
            "
          >
            Next Question
          </button>
          <p v-if="step === questionnaire.length - 1 && proceed">
            congrats on reaching the end!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleChoice from './MultipleChoice.vue';
import SingleChoice from './SingleChoice.vue';

export default {
  name: 'Questionnaire',
  components: {
    SingleChoice,
    MultipleChoice,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    questionnaire: Object,
  },
  data() {
    return {
      step: 0,
      proceed: false,
    };
  },
  methods: {
    nextStep(proceed) {
      this.proceed = proceed;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
